import { render, staticRenderFns } from "./TheadProfileCluster.vue?vue&type=template&id=fb0fe3ac"
import script from "./TheadProfileCluster.vue?vue&type=script&lang=js"
export * from "./TheadProfileCluster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports